import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _eff08154 = () => interopDefault(import('../pages/begeleiders/index.vue' /* webpackChunkName: "pages/begeleiders/index" */))
const _a969d254 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _e7dbd0bc = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _63aec04e = () => interopDefault(import('../pages/ouders/index.vue' /* webpackChunkName: "pages/ouders/index" */))
const _4efeccc2 = () => interopDefault(import('../pages/over.vue' /* webpackChunkName: "pages/over" */))
const _028f7154 = () => interopDefault(import('../pages/registreren.vue' /* webpackChunkName: "pages/registreren" */))
const _5f4f96f9 = () => interopDefault(import('../pages/vragen.vue' /* webpackChunkName: "pages/vragen" */))
const _52f98288 = () => interopDefault(import('../pages/vragen/index.vue' /* webpackChunkName: "pages/vragen/index" */))
const _5666c518 = () => interopDefault(import('../pages/vragen/_slug.vue' /* webpackChunkName: "pages/vragen/_slug" */))
const _0a77897a = () => interopDefault(import('../pages/begeleiders/netwerkactiviteiten/index.vue' /* webpackChunkName: "pages/begeleiders/netwerkactiviteiten/index" */))
const _7d3c03aa = () => interopDefault(import('../pages/begeleiders/tarieven.vue' /* webpackChunkName: "pages/begeleiders/tarieven" */))
const _18698037 = () => interopDefault(import('../pages/begeleiders/toolbox.vue' /* webpackChunkName: "pages/begeleiders/toolbox" */))
const _6404d9db = () => interopDefault(import('../pages/ouders/begeleiders/index.vue' /* webpackChunkName: "pages/ouders/begeleiders/index" */))
const _9b25a09e = () => interopDefault(import('../pages/ouders/omgeving.vue' /* webpackChunkName: "pages/ouders/omgeving" */))
const _692ab047 = () => interopDefault(import('../pages/ouders/tarieven.vue' /* webpackChunkName: "pages/ouders/tarieven" */))
const _a2fb79ea = () => interopDefault(import('../pages/begeleiders/netwerkactiviteiten/trainingen.vue' /* webpackChunkName: "pages/begeleiders/netwerkactiviteiten/trainingen" */))
const _18de2d51 = () => interopDefault(import('../pages/begeleiders/netwerkactiviteiten/webinars.vue' /* webpackChunkName: "pages/begeleiders/netwerkactiviteiten/webinars" */))
const _71fafbcb = () => interopDefault(import('../pages/ouders/begeleiders/zoeken.vue' /* webpackChunkName: "pages/ouders/begeleiders/zoeken" */))
const _08c0e832 = () => interopDefault(import('../pages/begeleiders/netwerkactiviteiten/_slug.vue' /* webpackChunkName: "pages/begeleiders/netwerkactiviteiten/_slug" */))
const _624e3893 = () => interopDefault(import('../pages/ouders/begeleiders/_slug.vue' /* webpackChunkName: "pages/ouders/begeleiders/_slug" */))
const _acd714e4 = () => interopDefault(import('../pages/blogs/_slug.vue' /* webpackChunkName: "pages/blogs/_slug" */))
const _ddd8b458 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _657b562c = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/begeleiders",
    component: _eff08154,
    name: "begeleiders"
  }, {
    path: "/blogs",
    component: _a969d254,
    name: "blogs"
  }, {
    path: "/contact",
    component: _e7dbd0bc,
    name: "contact"
  }, {
    path: "/ouders",
    component: _63aec04e,
    name: "ouders"
  }, {
    path: "/over",
    component: _4efeccc2,
    name: "over"
  }, {
    path: "/registreren",
    component: _028f7154,
    name: "registreren"
  }, {
    path: "/vragen",
    component: _5f4f96f9,
    children: [{
      path: "",
      component: _52f98288,
      name: "vragen"
    }, {
      path: ":slug",
      component: _5666c518,
      name: "vragen-slug"
    }]
  }, {
    path: "/begeleiders/netwerkactiviteiten",
    component: _0a77897a,
    name: "begeleiders-netwerkactiviteiten"
  }, {
    path: "/begeleiders/tarieven",
    component: _7d3c03aa,
    name: "begeleiders-tarieven"
  }, {
    path: "/begeleiders/toolbox",
    component: _18698037,
    name: "begeleiders-toolbox"
  }, {
    path: "/ouders/begeleiders",
    component: _6404d9db,
    name: "ouders-begeleiders"
  }, {
    path: "/ouders/omgeving",
    component: _9b25a09e,
    name: "ouders-omgeving"
  }, {
    path: "/ouders/tarieven",
    component: _692ab047,
    name: "ouders-tarieven"
  }, {
    path: "/begeleiders/netwerkactiviteiten/trainingen",
    component: _a2fb79ea,
    name: "begeleiders-netwerkactiviteiten-trainingen"
  }, {
    path: "/begeleiders/netwerkactiviteiten/webinars",
    component: _18de2d51,
    name: "begeleiders-netwerkactiviteiten-webinars"
  }, {
    path: "/ouders/begeleiders/zoeken",
    component: _71fafbcb,
    name: "ouders-begeleiders-zoeken"
  }, {
    path: "/begeleiders/netwerkactiviteiten/:slug",
    component: _08c0e832,
    name: "begeleiders-netwerkactiviteiten-slug"
  }, {
    path: "/ouders/begeleiders/:slug",
    component: _624e3893,
    name: "ouders-begeleiders-slug"
  }, {
    path: "/blogs/:slug",
    component: _acd714e4,
    name: "blogs-slug"
  }, {
    path: "/",
    component: _ddd8b458,
    name: "index"
  }, {
    path: "/*",
    component: _657b562c,
    name: "*"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
